import { IConfigState } from '../typings/IConfigState';
import {ConfigActions} from './config.actions';

export const initialConfigState: IConfigState = { currentView: '', currentEnvironment: '', currentMenu: ''};

export function configReducer (state: IConfigState  = initialConfigState, action: any) {

  switch (action.type) {
    case ConfigActions.UPDATE_CURRENT_VIEW: {
      const newState = {...state};
      newState.currentView = action.payload;
      return newState;
    }
    case ConfigActions.UPDATE_CURRENT_MENU: {
      const newState = {...state};
      newState.currentMenu = action.payload;
      return newState;
    }
    default:
      return state;
  }
};
